<template>
	<button class="btn btn-border btn--border btn--action" @click="ShowContactsRoutePopup = !ShowContactsRoutePopup">Как добраться</button>

	<transition name="modal">
		<ContactsRoutePopup v-if="ShowContactsRoutePopup" @close="ShowContactsRoutePopup = false" :img="img" />
	</transition>
</template>

<script>
import ContactsRoutePopup from "@/components/sections/Contacts/ContactsRoutePopup.vue";

export default {
	name: 'ContactsRoute',
	components: {ContactsRoutePopup},
	data() {
		return {
			ShowContactsRoutePopup: false
		}
	},
	props: {
		img: {
			type: String,
			default: () => ''
		}
	},
}
</script>

<style>

</style>
